import { css } from '@emotion/core'
import styled from '@emotion/styled'

import { Color } from '../../enums/color'
import { DefaultValue } from '../../enums/defaultValue'
import { getDefaultTransition } from '../../utils/getDefaultTransition'
import { getShadow } from '../../utils/getShadow'
import { PaymentPaneStatus } from './types/paymentPaneStatus'

interface PaymentPaneWrapperProps {
  status?: PaymentPaneStatus
  isCollapsed?: boolean
  withShadow?: boolean
  hasBanner?: boolean
}

export const PaymentPaneWrapper = styled.div<PaymentPaneWrapperProps>`
  height: 64px;
  border: 1px solid ${Color.Grey200};
  border-radius: ${DefaultValue.BorderRadius};
  background-color: ${Color.White};
  overflow: hidden;
  ${({ withShadow }) => withShadow && getShadow('raisedLight')}

  ${({ hasBanner }) => {
    if (hasBanner) {
      return css`
        border-top-left-radius: 0;
        border-top-right-radius: 0;
      `
    }
  }}

  ${({ isCollapsed }) => {
    if (!isCollapsed) {
      return css`
        height: 100%;
      `
    }
  }}

  ${({ status }) => {
    if (status && [PaymentPaneStatus.Success, PaymentPaneStatus.Error].includes(status)) {
      return css`
        position: relative;

        /* Colorized border around the wrapper */
        &:after {
          content: '';
          width: 100%;
          height: 100%;
          border: 1px solid ${status === PaymentPaneStatus.Success ? Color.Green400 : Color.Red700};
          border-radius: inherit;
          position: absolute;
          top: 0;
          left: 0;
          pointer-events: none;
        }
      `
    }
  }}
`

interface PaymentPaneItemsWrapperProps {
  status?: PaymentPaneStatus
  isCollapsed?: boolean
}

export const PaymentPaneItemsWrapper = styled.div<PaymentPaneItemsWrapperProps>`
  border-top: 1px solid transparent;
  ${getDefaultTransition('border-top-color')};

  ${({ isCollapsed }) => {
    if (!isCollapsed) {
      return css`
        border-top-color: ${Color.Grey150};
      `
    }
  }}
`
